import React from 'react';

import './styles.scss';
import { useIntl } from 'react-intl';

const RLMSDetails = () => {
  const intl = useIntl();
  return (
    <div>
      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.rateOverview',
          defaultMessage: 'Rate Overview',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.1c_overview_description',
          defaultMessage:
            'Save on energy costs by shifting your electricity usage (appliance use and EV charging) to off-peak hours, 11 pm to 7 am.',
        })}
      </p>

      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.howItWorks',
          defaultMessage: 'How it Works',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.1c_overview_description',
          defaultMessage:
            'Rate includes three rate periods: On-peak (7am-11pm), off-peak (11pm-7am), and super-peak (2pm-6pm (June-August, excluding weekend and holidays).',
        })}
      </p>
      <p className="text link">
        {intl.formatMessage({
          id: 'rlms.1c_overview_description',
          defaultMessage:
            'Customers are billed for electricity based on their kWh usage in each of the rate periods.',
        })}
      </p>
      <ul>
        <li>
          {intl.formatMessage({
            id: 'rlms.1c_overview_description',
            defaultMessage:
              'Off-Peak Period: Lowest delivery and commodity rates',
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: 'rlms.1c_overview_description',
            defaultMessage:
              'On-Peak Period: Higher deliver and commodity rates',
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: 'rlms.1c_overview_description',
            defaultMessage: 'Super-Peak Period: Highest commodity rate',
          })}
        </li>
      </ul>

      <br />

      <p className="text">
        {intl.formatMessage({
          id: 'rlms.1c_overview_description',
          defaultMessage:
            'Meter Install: Require a time-of-use meter to be installed in which customers are charged a monthly $3.11 fee to cover the cost of the enhanced metering necessary to record the usage in the three time periods.',
        })}
      </p>

      <p className="text">
        {intl.formatMessage({
          id: 'rlms.1c_overview_description',
          defaultMessage:
            'Minimum Time to participate on rate: Customers are required to stay on the rate for one year. At the end of the year, you can opt to move back to the SC-1 Standard tariff rate or to the SC-1C Optional Large Time of Use rate.',
        })}
      </p>

      <h3 className="title">
        {intl.formatMessage({
          id: 'rlms.whatItMeans',
          defaultMessage: 'What it Means for You',
        })}
      </h3>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.1c_overview_description',
          defaultMessage:
            'Lower Costs: Save on energy costs by shifting your appliance use and EV charging to off-peak hours.',
        })}
      </p>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.1c_overview_description',
          defaultMessage:
            'One-Time Credit: After one year, we will compare your SC-1 VTOU costs to the standard, non-time-of-use SC-1 rate. If you would have paid less on the SC-1 rate, you will receive a one-time credit for the difference.',
        })}
      </p>
      <p className="text">
        {intl.formatMessage({
          id: 'rlms.1c_overview_description',
          defaultMessage:
            'Annual Choice: Annually you can choose to stay on the SC-1 VTOU rate or return to the SC-1 rate.',
        })}
      </p>
      <a
        href="https://www.nationalgridus.com/Upstate-NY-Home/Rates/Service-Rates"
        className="cta-btn"
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage({
          id: 'rateDetails.learnMore',
          defaultMessage: 'Learn More about Service Rates',
        })}
      </a>
    </div>
  );
};

export default RLMSDetails;
